<template>
  <input
    :value="placeholderText"
    type="text"
    class="kbx-input">
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    placeholderText: 'stepTextPlaceholder',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Input.vue?3d4a825f
 **/